export const PENSION = {
  nickname: 'PRODUCTS.PENSION.shortname',
  isHidden: true,
  icon:'pension'
};
